export const OMNICHANNEL_STATUS = {
    WHATSAPP: "Whatsapp",
    INSTAGRAM: "Instagram",
    MESSENGER: "Messenger",
    WEB_WIDGET: "Web Widget",
    WEBSITE: "Website",
    CHRONOXAIWEBAPP: "Chronox AI Web App",
}